<template>
  <div>
    <v-autocomplete
      v-if="!preview"
      class="pt-0 mt-0"
      v-model="itemToAddUUID"
      :label="$t('components.pickers.itemPicker.addNewItem')"
      :items="filteredItemOptions"
      :item-text="formattedItemName"
      item-value="uuid"
      :search-input.sync="itemSearch"
      color="primary"
      @input.native="loadItems()"
      @change="addNewItem()"
      autocomplete="off"
      no-filter
    >
      <template v-slot:item="{ item }">
        <span>{{ formattedItemName(item) }}</span>
        <v-spacer></v-spacer>
        <v-chip outlined class="flex-ml-auto" v-if="item.is_public"
          ><v-icon class="mr-2">mdi-account-multiple</v-icon
          >{{ $t("components.pickers.itemPicker.publicTemplate") }}</v-chip
        >
        <!-- <licence-chip
          :feature="
            disableAddingPartsWithoutAdvancedLicenceBasedOnFeature(
              item.crm_group
            )
          "
          :enabled="
            disableAddingPartsWithoutAdvancedLicenceBasedOnFeature(
              item.crm_group
            ).enabled
          "
          float-direction="right"
        ></licence-chip> -->
      </template>
      <template v-slot:append-item>
        <div v-intersect="infiniteScrolling" />
      </template>
    </v-autocomplete>

    <v-list v-for="(item, index) in items" v-bind:key="index">
      <item-component
        v-bind:item="item"
        :readonly="readonly"
        v-on:delete-item="deleteItem(item)"
      />
    </v-list>
  </div>
</template>

<script>
import ItemComponent from "@/components/items/ItemComponent.vue";
import api from "@/utils/api.js";
// import LicenceChip from "@/components/general/LicenceChip";
import { mapGetters } from "vuex";

export default {
  name: "ItemPicker",
  components: {
    ItemComponent,
    // LicenceChip
  },
  props: {
    items: {
      type: Array,
      default: Array,
    },
    readonly: {
      type: Boolean,
      default: Boolean,
    },
    preview: {
      type: Boolean,
      default: Boolean,
    },
    feature: {
      type: String,
      default: String,
    },
  },
  data: () => ({
    itemSearch: "",
    isEditView: false,
    itemToAddUUID: null,
    itemOptions: [],
    timeout: null,
    getUuid: null,
    nextUrl: null,
  }),
  created() {
    this.loadItems(true);
  },
  computed: {
    ...mapGetters(["disableAddingPartsWithoutAdvancedLicenceHandler"]),
    // disableAddingPartsWithoutAdvancedLicenceBasedOnFeature() {
    //   return this.disableAddingPartsWithoutAdvancedLicenceHandler(this.feature);
    // },
    filteredItemOptions() {
      return this.itemOptions;
    },
  },
  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting) {
        let path = this.nextUrl.split("/").splice(5, 5).join("/");

        api.getItemNextPage(path).then((resp) => {
          this.getNextPage(resp);
          this.itemOptions = [...this.itemOptions, ...resp.data.results];
        });
      }
    },
    getNextPage(resp) {
      if (resp.data.next) {
        this.getUuid = resp.data.results[resp.data.results.length - 2].uuid;
        this.nextUrl = resp.data.next;
      } else {
        this.getUuid = null;
      }
    },
    formattedItemName: (item) => {
      if (item.vendor) {
        return item.vendor.name + " " + item.name;
      } else {
        return item.name;
      }
    },
    addNewItem() {
      this.$emit(
        "add:item",
        this.itemOptions.find((item) => item.uuid === this.itemToAddUUID)
      );
      this.$nextTick(() => {
        this.itemSearch = "";
        this.itemToAddUUID = null;
      });
    },
    deleteItem(item) {
      this.$emit("delete:item", this.items.indexOf(item));
    },

    loadItems(initalLoad = false) {
      let fetchItems = () => {
        return new Promise((resolve, reject) => {
          this.itemSearch = this.itemSearch ? this.itemSearch : "";
          api
            .getItemList({
              search: this.itemSearch,
              include_public: true,
              include_documents: true,
              autocomplete: true,
            })
            .then((resp) => {
              this.getNextPage(resp);
              this.itemOptions = resp.data.results.map((item) => {
                return {
                  ...item,
                  // NOTE: There is no crm_group property in item
                  // disabled:
                  //   this.disableAddingPartsWithoutAdvancedLicenceBasedOnFeature(
                  //     item.crm_group
                  //   ).disabled,
                };
              });
              resolve();
            });
        });
      };

      if (initalLoad) return fetchItems();

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchItems();
      }, 300); // delay
    },
  },
};
</script>
<style>
.flex-ml-auto {
  margin-left: auto;
}
</style>
